import { Link, usePage } from '@inertiajs/react'
import clsx from 'clsx'

const ADMIN_LINKS = [
  { name: 'Users',       href: '/admin/users' },
  { name: 'Roles',       href: '/admin/roles' },
  { name: 'Permissions', href: '/admin/permissions' },
  { name: 'Task Titles', href: '/admin/task_titles' },
]

export default function AdminNav() {
  const { url } = usePage()

  return (
    <div data-testid="admin-nav" className="mb-6">
      <nav className="flex items-center gap-1 border-b border-zinc-200 pb-3 dark:border-zinc-700">
        {ADMIN_LINKS.map((link) => {
          const isActive = url.startsWith(link.href)
          return (
            <Link
              key={link.href}
              href={link.href}
              preserveState
              data-testid={`admin-nav-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              className={clsx(
                'rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-400'
                  : 'text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-400 dark:hover:bg-white/5 dark:hover:text-white'
              )}
            >
              {link.name}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
